import React from 'react'
import styled from 'react-emotion'

const Header = styled('h2')`
	margin-top: 2rem;
	margin-bottom: 1rem;
`

const Body = styled('p')`
	text-align: center;
`

const Summary = ({ children }) => (
	<>
		<Header>Summary</Header>
		<Body>{children}</Body>
	</>
)

export default Summary